import { IAppReducerAction, IAppReducerOwnState } from "../shared/model";

const SET_NOTIFICATION_MESSAGES = "SET_NOTIFICATION_MESSAGES";
const SET_LAST_READ_VERSION = "SET_LAST_READ_VERSION";

const GET_NOTIFICATION_MESSAGES = "GET_NOTIFICATION_MESSAGES";
const GET_LAST_READ_VERSION = "GET_LAST_READ_VERSION";

export const initialState: IAppReducerOwnState = {
    notificationMessages: [],
    lastReadVersion: ""
};

export function reducer(appState: IAppReducerOwnState, action: IAppReducerAction): IAppReducerOwnState {
    switch (action.type) {
        case SET_NOTIFICATION_MESSAGES:
            return {
                ...appState,
                notificationMessages: action.notificationMessages
            };
        case SET_LAST_READ_VERSION:
            return {
                ...appState,
                lastReadVersion: action.lastReadVersion
            };
        case GET_NOTIFICATION_MESSAGES:
            return {
                ...appState,
                notificationMessages: appState.notificationMessages
            };
        case GET_LAST_READ_VERSION:
            return {
                ...appState,
                lastReadVersion: appState.lastReadVersion
            };
        default:
            return initialState;
    }
}
